const TipoUsuarioEnum = {
    INTERNO: "interno",
    EXTERNO: "externo",
  };
    
  export default TipoUsuarioEnum;
    